<div
  [hidden]="dataSource.data?.length"
  class="row center">
  <div class="col">
    <h2>{{ localizationConstants.REMINDERS_NO_REMINDERS_FOUND | translate }}</h2>
  </div>
</div>

<div
  [hidden]="!dataSource.data?.length"
  class="col">
  <div class="col-12 col-sm-6 col-md-3 u-mb--medium">
    <form class="c-search-form--full">
      <div class="c-input-group">
        <input
          type="text"
          name="search"
          id="input-search"
          [(ngModel)]="dataSource.filter"
          class="c-input c-input--beta"
          placeholder="{{ localizationConstants.REMINDERS_SEARCH | translate }}"
          required />

        <input
          *ngIf="!dataSource.filter"
          id="reminders-search"
          type="submit"
          class="c-button c-button--search c-button--search--sm"
          value="Search" />
        <input
          *ngIf="dataSource.filter"
          id="reminders-search-clear"
          (click)="dataSource.filter = ''"
          class="c-button c-button--search c-close-search c-button--search--sm"
          value="Clear" />
      </div>
    </form>
  </div>
  <div
    id="company-reminders"
    class="bg-white u-shadow u-scroll--horizontal">
    <div class="col">
      <table
        #companyRemindersTable
        mat-table
        multiTemplateDataRows
        matSort
        [dataSource]="dataSource"
        class="c-table c-table--expandable">
        <colgroup>
          <col
            span="1"
            style="width: 80%" />
          <col
            span="1"
            style="width: 10%" />
          <col
            span="1"
            style="width: 10%" />
        </colgroup>

        <ng-container matColumnDef="companyRemindersDetail">
          <th
            mat-header-cell
            *matHeaderCellDef>
            {{ localizationConstants.REMINDER_COMPANY | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let company"
            colspan="3"
            class="expandable-row-detail-cell">
            <div [@detailExpand]="company.expanded ? 'expanded' : 'collapsed'">
              <table
                mat-table
                [dataSource]="getDataSource(company.reminders)"
                class="detail-table">
                <ng-container
                  *ngFor="let col of reminderColumns; index as i"
                  [matColumnDef]="col.key">
                  <th
                    mat-header-cell
                    *matHeaderCellDef>
                    {{ col.title | translate }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let reminder">
                    <ng-container [ngSwitch]="col.key">
                      <div *ngSwitchCase="'type'">
                        {{ reminder.type | reminder: "type" | translate }}
                      </div>
                      <div *ngSwitchCase="'interval'">
                        {{ reminder.interval | reminder: "interval" | translate }}
                      </div>
                      <div *ngSwitchCase="'daysBefore'">{{ reminder.daysBefore }}</div>
                      <div *ngSwitchCase="'daysAfter'">{{ reminder.daysAfter }}</div>
                      <div *ngSwitchCase="'to'">
                        <div
                          *ngFor="let item of reminder.to | split: ';'"
                          class="c-chip">
                          {{ item }}
                        </div>
                      </div>
                      <div *ngSwitchCase="'cc'">
                        <div
                          *ngFor="let item of reminder.cc | split: ';'"
                          class="c-chip">
                          {{ item }}
                        </div>
                      </div>
                      <div *ngSwitchCase="'bcc'">
                        <div
                          *ngFor="let item of reminder.bcc | split: ';'"
                          class="c-chip">
                          {{ item }}
                        </div>
                      </div>
                    </ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="reminderAction1">
                  <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                  <td
                    mat-cell
                    *matCellDef="let reminder"
                    class="action">
                    <button
                      type="button"
                      class="button--sm button-primary button-block"
                      (click)="onEditReminder(reminder, company)">
                      {{ localizationConstants.BUTTON_EDIT | translate }}
                    </button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="reminderAction2">
                  <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                  <td
                    mat-cell
                    *matCellDef="let reminder"
                    class="action">
                    <button
                      type="button"
                      class="button--sm button-secondary button-block"
                      (click)="onRemoveReminder(reminder)"
                      [disabled]="reminder.pending">
                      <app-loading-icon *ngIf="reminder.pending"></app-loading-icon>
                      <span *ngIf="!reminder.pending">{{
                        localizationConstants.BUTTON_DELETE | translate
                      }}</span>
                    </button>
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="reminderColumnKeys"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: reminderColumnKeys"></tr>
              </table>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="companyAction1">
          <th
            mat-header-cell
            *matHeaderCellDef></th>
          <td
            mat-cell
            *matCellDef="let company">
            <button
              type="button"
              class="button--sm button-secondary button-block"
              (click)="onCreateReminder(company)"
              [disabled]="allRemindersCreated(company)"
              [attr.title]="
                (allRemindersCreated(company)
                  ? localizationConstants.REMINDERS_ALL_REMINDERS_CREATED
                  : ''
                ) | translate
              ">
              {{ localizationConstants.REMINDERS_CREATE_NEW | translate }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="companyAction2">
          <th
            mat-header-cell
            *matHeaderCellDef></th>
          <td
            mat-cell
            *matCellDef="let company">
            <button
              type="button"
              class="button--sm button-secondary button-block"
              (click)="onCreateAll(company)"
              [disabled]="allRemindersCreated(company)"
              [attr.title]="
                (allRemindersCreated(company)
                  ? localizationConstants.REMINDERS_ALL_REMINDERS_CREATED
                  : ''
                ) | translate
              ">
              {{ localizationConstants.REMINDERS_CREATE_DEFAULT | translate }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="fullName">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header>
            {{ localizationConstants.REMINDER_COMPANY | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let company"
            (click)="toggleExpandRow(company)"
            class="c-table__group-header"
            [class.is-toggled]="company.expanded"
            [class.c-clickable]="company.reminders.length > 0">
            {{ (company.fullName || "") + " " + (company.name || "") }}
            <i
              *ngIf="company.reminders.length > 0"
              class="c-icon c-icon--toggle"></i>
            <i
              *ngIf="!(company.reminders.length > 0)"
              class="c-icon c-icon--toggle-disabled"></i>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="companyColumnKeys"></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: companyColumnKeys"
          class="c-table__row"></tr>

        <tr
          mat-row
          *matRowDef="
            let company;
            columns: ['companyRemindersDetail'];
            when: shouldRenderReminderRow
          "
          class="expandable-row"
          [class.expanded-row]="company.expanded"></tr>
      </table>
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
